import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbsService } from '../../shared/breadcrumbs/breadcrumbs.service';
import { Observable } from 'rxjs';
import { PrivilegedTenant } from '../../shared/models/generated/ziroModels';
import { map } from 'rxjs/operators';
import { MicrosoftTenantsStateContext } from '../../shared/contexts/microsoft-tenants-state.context';

@Injectable()
/** For use in the admin tenant management section. */
export class TenantNavigationService {
  private route = inject(ActivatedRoute);
  private microsoftTenantsStateContext = inject(MicrosoftTenantsStateContext);
  private breadcrumbsService = inject(BreadcrumbsService);

  getTenantInfo(route?: ActivatedRoute): Observable<PrivilegedTenant> {
    const activeRoute = route || this.route;
    const { tenantId } = activeRoute.snapshot.params;

    return this.microsoftTenantsStateContext.fieldConfigState$.pipe(
      map((tenants) => {
        return tenants.privilegedTenants.find((t) => t.tenantId === Number(tenantId));
      }),
    );
  }

  buildTenantBreadcrumbs(
    tenant: PrivilegedTenant,
    additionalCrumbs: Array<{ label: string; url?: string; routerLink?: boolean }> = [],
  ): void {
    const baseCrumbs = [
      {
        label: 'tkey;admin.tenants.title',
        routerLink: false,
      },
      {
        label: tenant.tenantName,
        url: `/admin/tenants/${tenant.tenantId}/app-registration`,
        routerLink: true,
      },
    ];

    this.breadcrumbsService.updateBreadcrumbs([...baseCrumbs, ...additionalCrumbs]);
  }
}
